import request from './request';

export async function list(
  page: number,
  perPage: number,
  email?: string,
  firstName?: string,
  secondName?: string,
  username?: string,
  phone?: string,
  queueCourseIds?: string[],
  groupsCourseIds?: string[],
  sortColumn?: string,
  sortOrder?: string
) {
  return request('GET', '/api/students', {
    page,
    perPage,
    email,
    firstName,
    secondName,
    username,
    phone,
    queueCourseIds,
    groupsCourseIds,
    sortColumn,
    sortOrder,
  });
}

export async function create(
  email?: string,
  type?: number,
  firstName?: string,
  secondName?: string,
  phone?: string,
  data?: string,
  queueCourseIds?: string[]
) {
  return request('POST', '/api/students', {
    email,
    type,
    firstName,
    secondName,
    phone,
    data,
    queueCourseIds,
  });
}

export async function update(id: string, toUpdate: Record<string, unknown>) {
  return request('POST', `/api/students/${id}`, toUpdate);
}

export async function remove(id: string) {
  return request('DELETE', `/api/students/${id}`);
}

export async function getTypes(): Promise<{
  types: { label: string; value: number }[];
}> {
  return request('GET', `/api/students/types`);
}

export async function getQueueEntries(
  id: string,
  sortColumn?: string,
  sortOrder?: string
): Promise<{ queue: any[] }> {
  return request(
    'GET',
    `/api/students/${id}/queue?sortColumn=${sortColumn}&sortOrder=${sortOrder}`
  );
}

export async function addToCoursesQueues(
  id: string,
  courseIds: string[]
): Promise<{ queue: any[] }> {
  return request('POST', `/api/students/${id}/queue`, { courseIds });
}

export async function removeFromCoursesQueues(
  id: string,
  courseIds: string[]
): Promise<{ queue: any[] }> {
  return request('DELETE', `/api/students/${id}/queue`, { courseIds });
}
